<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.828 12.0001L14.657 14.8281L13.243 16.2431L9 12.0001L13.243 7.75708L14.657 9.17208L11.828 12.0001Z"
      fill="currentColor"
    />
  </svg>
</template>
